import { BasicsClass } from '@/common/BasicsClass';

export class BallRoomAPI extends BasicsClass {
    public apiUrls: any = new Map([
        ['getBallRoomTableList', {
            url: '/admin/user/roomList',
            name: 'list',
            label: '球房列表'
        }],
        ['add', {
            url: '/admin/user/roomAdd',
            name: 'add',
            label: '球房新增',
            // hidden: true
        }],

        ['edit', {
            url: '/admin/user/roomEdit',
            name: 'edit',
            label: '球房编辑',
        }],
        ['delete', {
            url: '/admin/user/roomDel',
            name: 'delete',
            label: '球房删除',
        }],
        ['groupList', {
            url: '/admin/user/groupList',
            name: 'groupList',
            label: '球房ID列表（下拉选择）',
        }]
    ])

    public getBallRoomTableList(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
      const apiUrls = this.apiUrls

      const url = apiUrls.get('getBallRoomTableList').url

      this.BasicPost(url, {
          ...params
      }, false, false, false, successCb, failCb, showLoading)
    }

    public addBallRoom(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
        const apiUrls = this.apiUrls

        const url = apiUrls.get('add').url

        this.BasicPost(url, {
            ...params
        }, false, false, false, successCb, failCb, showLoading)
    }

    public editBallRoom(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
        const apiUrls = this.apiUrls

        const url = apiUrls.get('edit').url

        this.BasicPost(url, {
            ...params
        }, false, false, false, successCb, failCb, showLoading)
    }

    public removeBallRoom(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
        const apiUrls = this.apiUrls

        const url = apiUrls.get('delete').url

        this.BasicPost(url, {
            ...params
        }, false, false, false, successCb, failCb, showLoading)
    }

    public groupList(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
        const apiUrls = this.apiUrls

        const url = apiUrls.get('groupList').url

        this.BasicPost(url, {
            ...params
        }, false, false, false, successCb, failCb, showLoading)
    }

}